import { createSelector } from '@reduxjs/toolkit'
import { lib } from '@gocanvas/client'
const { keyFieldEligibleTypes } = lib

export const types = ({ types }) => types

export const allEntryTypesSelector = createSelector(
  types,
  ({ entryTypes }) => entryTypes
)

export const alphaEntryTypesSelector = createSelector(
  allEntryTypesSelector,
  entryTypes =>
    [...entryTypes].sort((a, b) => a.description.localeCompare(b.description))
)

export const alphaKeyFieldTypesSelector = createSelector(
  alphaEntryTypesSelector,
  alphaEntryTypes =>
    alphaEntryTypes.filter(({ type }) => keyFieldEligibleTypes.includes(type))
)

export const operationTypesSelector = createSelector(
  types,
  ({ operationTypes }) => operationTypes
)
